/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { FfcMode_Enum, ffcMode_EnumFromJSON, ffcMode_EnumToJSON } from "./ffc_mode";
import { GainMode_Enum, gainMode_EnumFromJSON, gainMode_EnumToJSON } from "./gain_mode";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface BosonSettings {
  ffcMode: FfcMode_Enum;
  gainMode: GainMode_Enum;
}

function createBaseBosonSettings(): BosonSettings {
  return { ffcMode: 0, gainMode: 0 };
}

export const BosonSettings = {
  encode(message: BosonSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ffcMode !== 0) {
      writer.uint32(8).int32(message.ffcMode);
    }
    if (message.gainMode !== 0) {
      writer.uint32(16).int32(message.gainMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BosonSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBosonSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.ffcMode = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.gainMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BosonSettings {
    return {
      ffcMode: isSet(object.ffcMode) ? ffcMode_EnumFromJSON(object.ffcMode) : 0,
      gainMode: isSet(object.gainMode) ? gainMode_EnumFromJSON(object.gainMode) : 0,
    };
  },

  toJSON(message: BosonSettings): unknown {
    const obj: any = {};
    if (message.ffcMode !== 0) {
      obj.ffcMode = ffcMode_EnumToJSON(message.ffcMode);
    }
    if (message.gainMode !== 0) {
      obj.gainMode = gainMode_EnumToJSON(message.gainMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BosonSettings>, I>>(base?: I): BosonSettings {
    return BosonSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BosonSettings>, I>>(object: I): BosonSettings {
    const message = createBaseBosonSettings();
    message.ffcMode = object.ffcMode ?? 0;
    message.gainMode = object.gainMode ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
